import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ToasterService} from 'angular2-toaster';
import {DomSanitizer} from '@angular/platform-browser';

declare var URL: any;

@Component({
  selector: 'app-video-upload',
  templateUrl: './app-video-upload.component.html',
  styleUrls: ['./app-video-upload.component.scss']
})

export class AppVideoUploadComponent implements AfterViewInit, OnChanges {
  @ViewChild('videoInput') videoInput: ElementRef;
  @ViewChild('screenshotInput') screenshotInput: ElementRef;
  @Input() video: any;
  @Input() videoThumbnail: any;
  @Input() isUploading: boolean;
  @Input() showControls = false;
  @Input() hasScreenshot: boolean;
  @Output() videoChanged: EventEmitter<FormData> = new EventEmitter<FormData>();
  @Output() videoThumbnailChanged: EventEmitter<FormData> = new EventEmitter<FormData>();

  private cacheBreakUrl;
  private formData = new FormData();

  constructor(
    private toasterServices: ToasterService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('video changed', changes);
    if (typeof this.video === 'string') {
      this.cacheBreakUrl = this.video + '?' + Math.random();
    } else {
      this.cacheBreakUrl = this.video;
    }
    if (this.showControls) {
      this.enableControls();
    }
    if (this.video && this.hasScreenshot) {
      this.loadScreenshot();
    }
    this.mute();

  }

  ngAfterViewInit() {
    this.mute();
  }

  mute() {
    setTimeout(() => {
      const video = document.getElementById('player');
      if (video) {
        video['muted'] = 'muted';
      }
    }, 10);
  }

  enableControls() {
    const video = document.getElementById('player');
    if (video) {
      setTimeout(() => {
        video['controls'] = true;
      })
    }
  }

  videoChangeListener($event) {
    if ($event.target.files.length > 0) {
      this.isUploading = true;
      // this.toasterServices.pop('warning', 'Attention', 'Wait the end of upload');
      let video = document.getElementById('player');
      if (!video) {
        video = document.createElement('video');
        video.id = 'player';
      }
      video['muted'] = 'muted';
      const f: File = $event.target.files[0];
      const size = Math.round(f.size / 1024 / 1024);
      if (size > 20) {
        console.error('MAX SIZE EXCEEDED');
        this.toasterServices.pop('error', 'File too big', 'Max supported size is 20Mb');
        return;
      }
      const fr = new FileReader();
      fr.readAsArrayBuffer(f);

      fr.onloadend = () => {

        this.formData.delete('video');
        this.formData.append('video', f);
        this.videoChanged.emit(this.formData);

        this.video = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL($event.target.files[0]));

        if (this.hasScreenshot) {
          setTimeout(() => {
            const _VIDEO: any = video,
              _CANVAS: any = document.createElement('canvas'),
              screenshotContainer: any = document.querySelector('#screenshot-container');
            _CANVAS.id = 'screenshot-canvas';
            _VIDEO.addEventListener('loadedmetadata', function () {
              const ratio = _VIDEO['videoHeight'] / _VIDEO['videoWidth'];
              _CANVAS['width'] = 300;
              _CANVAS['height'] = 300 * ratio;
              _CANVAS.style.borderRadius = '4px';
              _CANVAS.style.borderStyle = 'dashed';
              _CANVAS.style.borderWidth = '1px';
              _CANVAS.style.borderColor = 'lightgrey';
              screenshotContainer.appendChild(_CANVAS);
            });
            this.isUploading = false;
          }, 10);
        }
      };
    }
  }

  private dataURLtoFile(dataurl, filename) {
    return new Promise((resolve) => {
      const arr = dataurl.split(',');
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const mime = arr[0].match(/:(.*?);/)[1],
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      resolve(new File([u8arr], filename, {type: mime}));
    });
  }

  screenshotChangeListener($event) {
    this.toasterServices.pop('warning', 'Attention', 'Wait the end of upload');
    // this.urltoFile($event, 'preview_img', 'image/jpeg')
    this.dataURLtoFile($event, 'preview_img')
      .then((f: File) => {
        // console.log('screenshotChangeListener', f);
        // this.formData = new FormData();
        this.formData.delete('video_thumbnail');
        this.formData.append('video_thumbnail', f);

        this.videoThumbnail = URL.createObjectURL(this.formData.get('video_thumbnail'));
        this.loadScreenshot();
        this.videoThumbnailChanged.emit(this.formData);
      });
  }


  takeScreenshot() {
    const _VIDEO: any = document.querySelector('#player'),
      _SCREENSHOT_CANVAS: HTMLCanvasElement = <HTMLCanvasElement>document.querySelector('#screenshot-canvas'),
      _CLEAN_CANVAS: HTMLCanvasElement = <HTMLCanvasElement>document.createElement('canvas'),
      _CLEAN_CANVAS_CTX = _CLEAN_CANVAS.getContext('2d'),
      _SCREENSHOT_CANVAS_CTX = _SCREENSHOT_CANVAS.getContext('2d'),
      ratio = _VIDEO['videoHeight'] / _VIDEO['videoWidth'],
      offsetW = _VIDEO['videoWidth'] / 300,
      offsetH = _VIDEO['videoHeight'] / 300;

    _CLEAN_CANVAS.setAttribute('crossOrigin', 'anonymous');
    _CLEAN_CANVAS.width = _VIDEO['videoWidth'];
    _CLEAN_CANVAS.height = _VIDEO['videoHeight'];
    _CLEAN_CANVAS_CTX.drawImage(_VIDEO, 0, 0, _VIDEO['videoWidth'], _VIDEO['videoHeight']);
    _SCREENSHOT_CANVAS_CTX.drawImage(_VIDEO, 0, 0, _VIDEO['videoWidth'] / offsetW, _VIDEO['videoHeight'] / offsetH * ratio);

    // console.log('pre toBlob');
    _CLEAN_CANVAS.toBlob(blob => {
      // console.log('toBlob');
      this.formData.delete('video_thumbnail');
      this.formData.set('video_thumbnail', blob);
      this.videoThumbnailChanged.emit(this.formData);
    });

  }

  loadScreenshot() {
    // console.log('loadScreenshot', this.videoThumbnail);
    const that = this;
    setTimeout(() => {
      const _VIDEO: any = document.querySelector('#player'),
        _CANVAS: any = document.createElement('canvas'),
        _CANVAS_CTX = _CANVAS.getContext('2d'),
        screenshotContainer: any = document.querySelector('#screenshot-container');
      _CANVAS.id = 'screenshot-canvas';

      let ratio = _VIDEO['videoHeight'] / _VIDEO['videoWidth'];
      _CANVAS['width'] = 300;
      _CANVAS['height'] = 300 * ratio;
      _CANVAS.style.borderRadius = '4px';
      _CANVAS.style.borderStyle = 'dashed';
      _CANVAS.style.borderWidth = '1px';
      _CANVAS.style.borderColor = 'lightgrey';

      if (that.videoThumbnail) {
        // console.log(that.videoThumbnail);
        const preview_img = new Image();
        preview_img.src = that.videoThumbnail;
        preview_img.onload = function () {
          ratio = preview_img['naturalHeight'] / preview_img['naturalWidth'];
          _CANVAS['width'] = 300;
          _CANVAS['height'] = 300 * ratio;
          const offsetW = preview_img.naturalWidth / 300;
          const offsetH = preview_img.naturalHeight / 300;
          _CANVAS_CTX.drawImage(preview_img, 0, 0, preview_img.naturalWidth / offsetW, preview_img.naturalHeight / offsetH * ratio);
        };
      } else {
        _CANVAS['height'] = 300 * 9 / 16;
      }
      const screenshotCanvas = document.getElementById('screenshot-canvas');
      if (screenshotCanvas) {
        screenshotCanvas.parentNode.removeChild(screenshotCanvas);
      }
      screenshotContainer.appendChild(_CANVAS);
    }, 10);
  }


  selectVideo() {
    this.videoInput.nativeElement.click()
  }

  deleteVideo() {
    const video = document.getElementById('player');
    if (video) {
      this.video = '';
    }
    this.videoChanged.emit();
  }

  // playVideo(event) {
  //   event.stopPropagation();
  //   const player = document.getElementById('player') as HTMLVideoElement;
  //   if (!player.paused) {
  //     player.pause();
  //     this.isPlaying = false;
  //   } else {
  //     player.play();
  //     this.isPlaying = true;
  //   }
  // }


}
